import { faEye } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, Modal } from 'antd';
import { useState } from 'react';
import styled from 'styled-components';
import { getImageUrl } from 'utils/tools';

export default function AvatarCol({ src }) {
  const [visible, setVisible] = useState(false);
  const handleVisible = () => {
    if (src) {
      setVisible(true);
    }
  };

  return (
    <>
      <AvatarColStyles onClick={handleVisible}>
        <Avatar
          src={src ? getImageUrl(src) : `/images/no-item.png`}
          size="large"
          shape="square"
        />
        {src && (
          <div className="avatarCol-eye">
            <FontAwesomeIcon icon={faEye} className="text-white" />
          </div>
        )}
      </AvatarColStyles>
      {!!visible && src && (
        <Modal footer={null} open={visible} onCancel={() => setVisible(false)}>
          <img src={getImageUrl(src, 800)} className="w-full" />
        </Modal>
      )}
    </>
  );
}

const AvatarColStyles = styled.div`
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  width: 40px;
  border-radius: 8px;

  .avatarCol-eye {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    visibility: hidden;
    transition: 0.3s all linear;
  }

  &:hover {
    cursor: pointer;

    .avatarCol-eye {
      visibility: visible;
      background-color: var(--bg-black-03);
    }
  }
`;
